import { withTolgee, Tolgee, I18nextPlugin, DevTools, BackendFetch } from '@tolgee/i18next';
import i18n from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

const tolgee = Tolgee()
    .use(DevTools())
    .use(I18nextPlugin())
    .use(BackendFetch())
    .init({
        apiUrl: process.env.REACT_APP_TOLGEE_API_URL,
        apiKey: process.env.REACT_APP_TOLGEE_API_KEY
    });

withTolgee(i18n, tolgee)
    .use(ICU)
    .use(initReactI18next)
    .init({
        lng: "af",
        fallbackLng: "af",
        ns: ["translation", "cron"],
        defaultNS: "translation",
        interpolation: {
            escapeValue: false
        },
        keySeparator: false,
        saveMissing: true
    });

export const lngs = {
    af: { nativeName: 'Afrikaans' },
    en: { nativeName: 'English' }
};

export default i18n;